<template>
  <div>
    <breadcrumb :routerList="[{to:'/agent/weeklyMeetingList',title:'网络运营会列表'},{title:'新增网络运营会'}]"/>
    <div class="h-content">
      <div class="h-row h-mrt0">
        <div class="h-rowIn">
          <div class="h-rowBox">
            <el-form ref="form1" :model="formValue" :rules="rules">
              <div class="h-rowCon">
                <div class="h-pieceIn2">
                  <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                    <h1>新增网络运营会</h1>
                  </div>
                  <div class="h-pieceCon2">
                    <div class="h-formLine">
                      <div class="margin-top el-descriptions">
                        <div class="el-descriptions__body">
                          <table class ="meeting-table el-descriptions__table is-bordered bordered-spacing" style="table-layout: fixed; width: 100%;">
                            <tr>
                              <th colspan="12" class="my-label el-descriptions-item__cell el-descriptions-item__label ">
                                客户基本信息
                              </th>
                            </tr>
                            <tr>
                              <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                代理商名称
                              </th>
                              <td colspan="3" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="agentName">
                                  <el-select
                                      filterable
                                      v-model="formValue.agentName"
                                      placeholder="请选择"
                                      @change="changeAgent"
                                      clearable
                                      style="width: 100%;"
                                  >
                                    <el-option
                                        v-for="(item,index4) in agentList"
                                        :key="index4"
                                        :label="item.agentName"
                                        :value="item.agentCode">
                                    </el-option>
                                  </el-select>
                                </el-form-item>
                              </td>
                              <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                签约渠道
                              </th>
                              <td colspan="4" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="channelCode">
<!--                                  {{formValue.channelName}}-->
                                  {{formValue.channelCode | dictname('sales_region')}}
                                </el-form-item>
                              </td>
                              <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                所在省区
                              </th>
                              <td colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="provinceCode">
<!--                                  {{formValue.provinceName}}-->
                                  {{formValue.provinceCode | dictname('YlSalesArea_chanpin')}}
                                </el-form-item>
                              </td>
                            </tr>
                            <tr>
                              <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                召开人
                              </th>
                              <td colspan="3" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="conveneName">
                                  {{formValue.conveneName}}
                                </el-form-item>
                              </td>
                              <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                参会人
                              </th>
                              <td colspan="4" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="participants" >
                                  <el-input v-model="formValue.participants" placeholder="请输入参会人" clearable/>
                                </el-form-item>
                              </td>
                              <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                运营会时间
                              </th>
                              <td colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="weekTime" >
                                  {{formValue.weekTime}}
                                </el-form-item>
                              </td>
                            </tr>
                            <tr>
                              <th colspan="12" class="my-label el-descriptions-item__cell el-descriptions-item__label">客户签约目标</th>
                            </tr>
                            <tr>
                              <th colspan="7"  class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">月度履约预测</th>
                              <th colspan="5"  class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">本月预测支撑明细</th>
                            </tr>
                            <tr>
                              <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">月份</th>
                              <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">领域</th>
                              <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">本月目标(万)</th>
                              <th colspan="2" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">本月预计达成（万）</th>
                              <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">预测履约率（%）</th>
                              <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">实际履约率（%）</th>
                              <th colspan="5" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">填写</th>
                            </tr>
                            <tr>
                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="monthOne">
                                  <template slot-scope="scope">
                                    <div style="text-align: center;">
                                      {{formValue.monthOne}}
                                    </div>
                                  </template>
                                </el-form-item>
                              </td>
                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item  prop="fieldOne">
                                  <template slot-scope="scope">
                                    <div style="text-align: center;">
                                     {{formValue.fieldOne}}
                                    </div>
                                  </template>
                                </el-form-item>
                              </td>
                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item  prop="monthTargetOne" >
                                  <template slot-scope="scope">
                                    <div style="text-align: right;">
                                      {{formValue.monthTargetOne }}
                                    </div>
                                  </template>
                                </el-form-item>
                              </td>
                              <td colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="monthExpectOne">
                                  <el-input v-model="formValue.monthExpectOne" clearable @change="handleCountOne"
                                            oninput="value=value.replace(/[^\d.]/g,'')" placeholder="请输入本月预计达成"/>
                                </el-form-item>
                              </td>
                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="ycCompletionRateOne">
                                  <template slot-scope="scope">
                                    <div style="text-align: right;">
                                      {{formValue.ycCompletionRateOne}}
                                    </div>
                                  </template>
                                </el-form-item>
                              </td>
                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="completionRateOne">
                                  <template slot-scope="scope">
                                    <div style="text-align: right;">
                                      {{formValue.completionRateOne}}
                                    </div>
                                  </template>
                                </el-form-item>
                              </td>
                              <td colspan="5" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="detailOne">
                                  <el-input type="textarea" :autosize="{ minRows: 1, maxRows: 10 }"
                                            v-model="formValue.detailOne"
                                            placeholder="请填写本月预测支撑明细"
                                            clearable/>
                                </el-form-item>
                              </td>
                            </tr>
                            <tr v-if="formValue.monthTwo">
                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="monthTwo">
                                  <template slot-scope="scope">
                                    <div style="text-align: center;">
                                      {{formValue.monthTwo}}
                                    </div>
                                  </template>
                                </el-form-item>
                              </td>
                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item  prop="fieldTwo">
                                  <template slot-scope="scope">
                                    <div style="text-align: center;">
                                          {{formValue.fieldTwo}}
<!--                                      生命科学-->
                                    </div>
                                  </template>
                                </el-form-item>
                              </td>
                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item  prop="monthTargetTwo" >
                                  <template slot-scope="scope">
                                    <div style="text-align: right;">
                                      {{formValue.monthTargetTwo }}
                                    </div>
                                  </template>
                                </el-form-item>
                              </td>
                              <td colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="monthExpectTwo">
                                  <el-input v-model="formValue.monthExpectTwo" clearable @change="handleCountTwo"
                                            oninput="value=value.replace(/[^\d.]/g,'')"/>
                                </el-form-item>
                              </td>
                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="ycCompletionRateTwo">
                                  <template slot-scope="scope">
                                    <div style="text-align: right;">
                                      {{formValue.ycCompletionRateTwo}}
                                    </div>
                                  </template>
                                </el-form-item>
                              </td>
                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="completionRateTwo">
                                  <template slot-scope="scope">
                                    <div style="text-align: right;">
                                      {{formValue.completionRateTwo}}
                                    </div>
                                  </template>
                                </el-form-item>
                              </td>
                              <td colspan="5" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="detailTwo">
                                  <el-input type="textarea" :autosize="{ minRows: 1, maxRows: 10 }"  v-model="formValue.detailTwo" clearable/>
                                </el-form-item>
                              </td>
                            </tr>
                            <!-- tbody v-for=(item,index) in lingyuList -->

                            <tr>
                              <th colspan="12" class="my-label el-descriptions-item__cell el-descriptions-item__label">签约目标用户</th>
                            </tr>
                            <tr>
                              <th colspan="2" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                目标用户个数
                              </th>
                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="targetUserNum" >
                                  <template slot-scope="scope">
                                    <div style="text-align: right;">
                                      {{formValue.targetUserNum}}
                                    </div>
                                  </template>
                                </el-form-item>
                              </td>
                              <th colspan="2" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                累计覆盖用户
                              </th>
                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="leijiUserNum" >
                                  <template slot-scope="scope">
                                    <div style="text-align: right;">
                                      {{formValue.leijiUserNum}}
                                    </div>
                                  </template>
                                </el-form-item>
                              </td>
                              <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                当年覆盖用户
                              </th>
                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="yearUserNum" >
                                  <template slot-scope="scope">
                                    <div style="text-align: right;">
                                      {{formValue.yearUserNum}}
                                    </div>
                                  </template>
                                </el-form-item>
                              </td>
                              <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                累计覆盖率(%)
                              </th>
                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="leijiCoverage" >
                                  <template slot-scope="scope">
                                    <div style="text-align: right;">
                                      {{formValue.leijiCoverage}}
                                    </div>
                                  </template>
                                </el-form-item>
                              </td>
                              <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                当年覆盖率(%)
                              </th>
                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="yearCoverage">
                                  <template slot-scope="scope">
                                    <div style="text-align: right;">
                                      {{formValue.yearCoverage}}
                                    </div>
                                  </template>
                                </el-form-item>
                              </td>
                            </tr>
                            <tr>
                              <th colspan="3" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                未覆盖且无漏斗用户个数
                              </th>
                              <th colspan="9" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                本周行动计划
                              </th>
                            </tr>
                            <tr>
                              <td colspan="3" class="el-descriptions-item__cell el-descriptions-item__content">
                                <a style="color: #3794ef;cursor: pointer" @click="handleDialog">
                                  {{formValue.noCoveredNoloudUserNum}}
                                </a>
                              </td>
                              <td v-if="formValue.noCoveredNoloudUserNum==0" colspan="9" class="el-descriptions-item__cell el-descriptions-item__content" style="white-space: pre-line;text-align: left!important;">
                                <el-input v-model="formValue.handInput"
                                          type="textarea"
                                          :autosize="{ minRows: 1, maxRows: 10 }"
                                          clearable placeholder="请填写"
                                />
                              </td>
                              <td v-if="formValue.noCoveredNoloudUserNum>0" colspan="5" class="el-descriptions-item__cell el-descriptions-item__content" style="white-space: pre-line;text-align: left!important;">
                                {{formValue.weekPlan}}
                              </td>
                              <td v-if="formValue.noCoveredNoloudUserNum>0" colspan="4" class="el-descriptions-item__cell el-descriptions-item__content" style="white-space: pre-line;text-align: left!important;">
                                <el-input v-model="formValue.handInput"
                                          type="textarea"
                                          :autosize="{ minRows: 1, maxRows: 10 }"
                                          clearable placeholder="请填写"
                                />
                              </td>
                            </tr>
                            <tr>
                              <th colspan="12" class="my-label el-descriptions-item__cell el-descriptions-item__label">进销存盘点</th>
                            </tr>
                            <tr>
                              <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                累计下单(万)
                              </th>
                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="leijiOrder">
                                  <template slot-scope="scope">
                                    <div style="text-align: right;">
                                      {{formValue.leijiOrder}}
                                    </div>
                                  </template>
                                </el-form-item>
                              </td>
                              <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                累计安装(万)
                              </th>
                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="leijiInstall">
                                  <template slot-scope="scope">
                                    <div style="text-align: right;">
                                      {{formValue.leijiInstall}}
                                    </div>
                                  </template>
                                </el-form-item>
                              </td>
                              <th colspan="1" rowspan="2" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                累计库存(万)
                              </th>
                              <td colspan="1" rowspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="leijiInventory">
                                  <template slot-scope="scope">
                                    <div style="text-align: right;">
                                      {{formValue.leijiInventory}}
                                    </div>
                                  </template>
                                </el-form-item>
                              </td>
                              <th colspan="6" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                库存消化行动方案
                              </th>
                            </tr>
                            <tr>
                              <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                当年下单(万)
                              </th>
                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="yearOrder">
                                  <template slot-scope="scope">
                                    <div style="text-align: right;">
                                      {{formValue.yearOrder}}
                                    </div>
                                  </template>
                                </el-form-item>
                              </td>
                              <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                当年安装(万)
                              </th>
                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="yearInstall">
                                  <template slot-scope="scope">
                                    <div style="text-align: right;">
                                      {{formValue.yearInstall}}
                                    </div>
                                  </template>
                                </el-form-item>
                              </td>
                              <td colspan="6" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="inventoryDigestionPlan">
                                  <el-input v-model="formValue.inventoryDigestionPlan" clearable placeholder="请填写"/>
                                </el-form-item>
                              </td>
                            </tr>

                            <tr>
                              <th colspan="12" class="my-label el-descriptions-item__cell el-descriptions-item__label">招标项目</th>
                            </tr>
                            <tr>
                              <th colspan="6" class="my-label el-descriptions-item__cell el-descriptions-item__label is-bordered-label">未来3个月内招标项目</th>
                              <th colspan="6" class="my-label el-descriptions-item__cell el-descriptions-item__label is-bordered-label">本月开标项目</th>
                            </tr>
                            <tr>
                              <td colspan="6" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="threeMonthProject">
                                  <el-input type="textarea"
                                            :autosize="{ minRows: 1, maxRows: 10 }"
                                            v-model="formValue.threeMonthProject" clearable
                                            placeholder="请填写"
                                  />
                                </el-form-item>
                              </td>
                              <td colspan="6" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="monthProject">
                                  <el-input type="textarea"
                                            :autosize="{ minRows: 1, maxRows: 10 }"
                                            v-model="formValue.monthProject" clearable
                                            placeholder="请填写"
                                  />
                                </el-form-item>
                              </td>
                            </tr>

                            <tr>
                              <th colspan="12" class="my-label el-descriptions-item__cell el-descriptions-item__label">营销活动及培训产品</th>
                            </tr>
                            <tr>
                              <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                活动类型
                              </th>
                              <td colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="activityType">
                                  <el-input v-model="formValue.activityType" clearable placeholder="请填写"/>
                                </el-form-item>
                              </td>
                              <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                行动计划
                              </th>
                              <td colspan="4" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="activityPlan">
                                  <el-input type="textarea"
                                            :autosize="{ minRows: 1, maxRows: 10 }"
                                            v-model="formValue.activityPlan" clearable
                                            placeholder="请填写"
                                  />
                                </el-form-item>
                              </td>
                              <th colspan="2" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                预计下次召开时间
                              </th>
                              <td colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item  prop="activityTime">
                                  <el-date-picker
                                      :clearable="false"
                                      type="date"
                                      value-format="yyyy-MM-dd"
                                      placeholder="选择时间"
                                      v-model="formValue.activityTime"
                                      :picker-options="pickerOptions"
                                      style="width: 100%;"
                                  ></el-date-picker>
                                </el-form-item>
                              </td>
                            </tr>

<!--                            <tr>-->
<!--                              <th colspan="12" class="my-label el-descriptions-item__cell el-descriptions-item__label">产品培训</th>-->
<!--                            </tr>-->
                            <tr>
                              <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                培训产品
                              </th>
                              <td colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                <el-form-item prop="trainingproduct">
                                  <el-input v-model="formValue.trainingproduct" clearable placeholder="请填写"/>
                                </el-form-item>
                              </td>
                              <th colspan="1" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                图片
                              </th>
                              <td colspan="8" class="el-descriptions-item__cell el-descriptions-item__content" style="padding-bottom: 0">
                                <brupload
                                    :limit="3"
                                    :isTp = true
                                    :tpFlag = true
                                    :refid="refid"
                                    reftype="周清会议纪要-培训照片"
                                    :uploadflag="true"
                                    :delflag="true"
                                    :showtime="false">
                                </brupload>
                              </td>
                            </tr>

                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-form>
          </div>
        </div>
      </div>

      <el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible" width="50%" class="body_dilog ljjdiolog" title="行动计划">
        <div class="h-rowIn" >
          <div class="h-rowBox">
            <div class="h-rowCon" style="padding-bottom: 0.8rem;">
              <el-table
                  ref="multipleTable"
                  :data="tableData"
                  stripe
                  style="width: 100%"
                  :border="true"
                  max-height="220"
              >
                <el-table-column
                    prop="customerName"
                    :show-overflow-tooltip="true"
                    label="用户单位名称"
                    width="200"
                >
                </el-table-column>
                <el-table-column
                    prop="weekPlan"
                    :show-overflow-tooltip="true"
                    label="行动计划">
                  <template slot-scope="scope">
                    <el-input type="textarea" :autosize="{ minRows: 1, maxRows: 10 }" v-model="scope.row.weekPlan" clearable/>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="h-tableB" style="text-align: right">
              <div class="h-tableBL">
                <el-button class="h-btn h-formBtn h-bgblueQ" @click="handleCancel">取消</el-button>
                <el-button class="h-btn h-formBtn h-bgblueQ" @click="handleSave">保存</el-button>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>

      <div class="h-txtCenter" style="margin: 0.3rem 0;">
        <el-button class="h-btn h-bBtn h-bgwhite" @click="backS">返回</el-button>
        <el-button class="h-btn h-bBtn h-bgblueQ2" @click="submit">确认提交</el-button>
      </div>



      <div class="h-row h-mrt0">
        <div class="h-rowIn">
          <div class="h-rowBox">
            <div class="h-rowCon">
              <div class="h-pieceIn2">
                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                  <h1>网络运营会历史记录</h1>
                </div>
              </div>
              <el-collapse v-model="activeNames" @item-click="handleItemClick">
                <el-collapse-item :key="item.cdate" :title="item.cdate + '运营会记录'" :name="item.cdate" v-for="item in listData" >
                  <template slot="title">
                    {{item.cdate}} 运营会记录 <i :key="item.id" :class="activeNames.includes(item.cdate)?'el-icon-arrow-down':'el-icon-arrow-up'" style="margin-left: 4px"></i>
                  </template>
                  <see-weekly-meeting :ref="'child'+ item.cdate" :key="item.id" :type="typeLog"/>
                </el-collapse-item>
              </el-collapse>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ss from '@/api/SystemService'
import moment from "moment";
import weeklyMeetingApi from "@/api/loud/weeklyMeeting/weeklyMeetingApi";
import seeWeeklyMeeting from "@/views/loud/agent/weeklyMeeting/seeWeeklyMeeting.vue";
export default {
  components:{
    seeWeeklyMeeting
  },
  data(){
    return{
      agentList: [],
      formValue:{
        // 客户基本信息
        agentName: '',//代理商名称
        agentCode: '',//代理商编码
        channelName: '',//签约渠道
        channelCode: '',//渠道编码
        provinceName: '',//地区
        provinceCode: '',
        conveneCode: '',//召开人编码
        conveneName: '',//召开人姓名
        participants: '',//参会人
        weekTime: '',//运营会时间
        //客户签约目标第一个领域
        monthOne: '',//月份
        fieldOne: '',//领域
        monthTargetOne: '',//本月目标
        monthExpectOne: '',//本月预期
        ycCompletionRateOne: '',//预测履约率
        completionRateOne: '',//实际履约率
        detailOne: '',//本月预测支撑明细填写
        //客户签约目标第二个领域
        monthTwo: '',//月份
        fieldTwo: '',//领域
        monthTargetTwo: '',//本月目标
        monthExpectTwo: '',//本月预期
        ycCompletionRateTwo: '',//预测履约率
        completionRateTwo: '',//实际履约率
        detailTwo: '',//本月预测支撑明细填写
      // 签约目标用户
        targetUserNum: '',//目标用户个数
        leijiUserNum: '',//累计覆盖用户
        yearUserNum: '',//当年覆盖用户
        leijiCoverage: '',//累计覆盖率
        yearCoverage: '',//当年覆盖率
        noCoveredNoloudUserNum: '',//未覆盖且无漏斗用户个数
        weekPlan: '',//本周行动计划
        handInput: '',//本周行动假话
        planDetailList: [],
      // 进销存盘点
        leijiOrder: '',//累计下单
        leijiInstall: '',//累计安装
        leijiInventory: '',//累计库存
        inventoryDigestionPlan: '',//库存消化行动方案
        yearOrder: '',//当年下单
        yearInstall: '',//当年安装
      // 招标项目
        threeMonthProject: '', //未来3个月内招标项目
        monthProject: '',  //本月开标项目
      // 营销活动
        activityType: '',//活动类型
        activityPlan: '',//行动计划
        activityTime: '',//预计召开时间
      // 产品培训
        trainingproduct: '',//培训产品
        fileId: ''
      },
      rules: {
        agentName: [
          { required: true, message: '请选择代理商', trigger: 'blur' }
        ],
        participants: [
          { required: true, message: '请输入参会人', trigger: 'blur' }
        ],
        monthExpectOne: [
          { required: true, message: '请输入本月预计达成', trigger: 'blur' }
        ],
        monthExpectTwo: [
          { required: true, message: '请输入本月预计达成', trigger: 'blur' }
        ],
        detailOne: [
          { required: true, message: '请填写本月预测支撑明细', trigger: 'blur' }
        ],
        detailTwo: [
          { required: true, message: '请填写本月预测支撑明细', trigger: 'blur' }
        ],
        inventoryDigestionPlan: [
          { required: true, message: '请填写库存消化行动方案', trigger: 'blur' }
        ],
        threeMonthProject: [
          { required: true, message: '请填写未来3个月招标项目', trigger: 'blur' }
        ],
        monthProject: [
          { required: true, message: '请填写本月开标项目', trigger: 'blur' }
        ],
        activityType: [
          { required: true, message: '请填写活动类型', trigger: 'blur' }
        ],
        activityPlan: [
          { required: true, message: '请填写行动计划', trigger: 'blur' }
        ],
        activityTime: [
          { required: true, message: '请选择预计召开时间', trigger: 'blur' }
        ],
        trainingproduct: [
          { required: true, message: '请填写培训产品', trigger: 'blur' }
        ]
      },
      refid: null,
      dialogFormVisible: false,
      tableData: [],
      activeNames: [],
      listData: [],//创建时先获取当前月份，请求列表得到当前月份数据
      typeLog: false,
      qudao: [],
      tableDetailList: [],
      planDetailList: [],
      pickerOptions: {
        disabledDate(v) {
          return v.getTime() < new Date().getTime() - 86400000;//  - 86400000是否包括当天
        }
      }
    }
  },
  methods:{
    //查询渠道
    selectChannel() {
      ss.Dictservice.listbycategory("sales_region").then(response => {
        this.qudao = response;
      })
    },
    //获取代理商
    getUserList(){
      weeklyMeetingApi.selectMeetUserList().then(res=>{
        this.agentList = res
      })
    },
    //点击代理商
    changeAgent(val){
      //获取销售渠道中文
      const selectedOption = this.agentList.find(item => item.agentCode === val);
      let channelCodeStr = selectedOption.channelCode;
      // 将字符串转换为数组
      const codes = channelCodeStr.split(',');
      let channelName = ''
      codes.forEach(item=>{
        channelName += this.$store.getters.dictname("sales_region",item) + ','
      })
      const formattedStr = channelName.replace(/[,，]+$/, '');
      this.formValue.weekPlan = ''
      //获取所在省区
      weeklyMeetingApi.selectUserInfo({agentCode:val}).then(res=>{
        this.formValue = {
          // ...this.formValue,
          weekTime: moment(new Date()).format('YYYY-MM-DD'),
          ...selectedOption,
          ...res,
          channelName: formattedStr,
          provinceName: this.$store.getters.dictname("YlSalesArea_chanpin",selectedOption.provinceCode)
        }
        this.planDetailList = JSON.parse(JSON.stringify(res.planDetailList));
      })
      this.selectByWeek(val)
    },
    //计算预测履约率
    handleCountOne(val){
      if(val){
        this.formValue.ycCompletionRateOne = ((this.formValue.monthExpectOne/this.formValue.monthTargetOne)*100).toFixed(2)
      }
    },
    handleCountTwo(val){
      if(val){
        this.formValue.ycCompletionRateTwo = ((this.formValue.monthExpectTwo/this.formValue.monthTargetTwo)*100).toFixed(2)
      }
    },
    //展开节点事件
    handleItemClick(panel){
      // panel 对象包含以下属性：
      // - name: 面板的 name
      // - title: 面板的标题
      // - isActive: 是否处于激活状态,是点击前的状态,是相反的
      if(!panel.isActive){
        const arr = this.listData.filter(item=> item.cdate == panel.name)
        this.$nextTick(()=>{
          let ref = this.$refs['child'+ panel.name]
          ref[0].updateData(arr[0])
        })
      }
    },
    //点击查看弹窗
    handleDialog(){
      if(this.formValue.weekPlan){
        // 1. 按行拆分（\n）
        const lines = this.formValue.weekPlan.split('\n');
        // 2. 每行按冒号分割，并还原为对象数组
        const restoredArray = lines.map(line => {
          const [customerName, weekPlan] = line.split(':'); // 按冒号分割
          return { customerName, weekPlan }; // 返回对象结构
        });
        // 遍历 array2，如果某元素在 array1 中存在，则合并数据
        let array2 = JSON.parse(JSON.stringify(this.planDetailList))
        const mergedArray = array2.map(itemB => {
          const matchedItem = restoredArray.find(itemA => itemA.customerName == itemB.customerName);
          return matchedItem ? { ...itemB, ...matchedItem } : itemB;
        });
        this.tableData = mergedArray;
      } else{
        this.tableData = JSON.parse(JSON.stringify(this.planDetailList));
      }
      this.dialogFormVisible = true
    },
    //取消保存
    handleCancel(){
      this.dialogFormVisible = false
    },
    handleSave(){
      //点击保存，将输入后的值赋值给新的List
      this.tableDetailList = this.tableData.filter(item => item.weekPlan != null && item.weekPlan !== '');
      // 使用特殊格式序列化
      const string = this.tableDetailList.map(obj => `${obj.customerName}:${obj.weekPlan}`).join('\n');
      this.formValue.weekPlan = string
      this.dialogFormVisible = false
    },
    //返回
    backS() {
      this.$router.go(-1);
    },
    submit(){
      var subflag = false;
      this.$refs['form1'].validate((valid) => {
        if (valid) {
          if(this.formValue.noCoveredNoloudUserNum>0 && !this.formValue.weekPlan){
              this.$message.warning('请点击未覆盖且无漏斗用户个数填写本周行动计划')
              return;
          }
          if(this.formValue.noCoveredNoloudUserNum == 0 && !this.formValue.handInput){
            this.$message.warning('请填写本周行动计划')
            return;
          }
          subflag = true;
          this.formValue.fileId  = this.refid
          let params = {
            ...this.formValue,
            planDetailList: this.tableData
          }
          weeklyMeetingApi.insert(params).then(res=>{
            if(res.f){
              this.$router.push({path: "/agent/weeklyMeetingList"});
            }
          })
        } else {
          this.$msg.msge("请完善信息后再提交！");
          return false;
        }
      });
    },
    selectByWeek(val){
      let param = {
        agentCode: val,
      }
      weeklyMeetingApi.selectByWeek(param).then(res=>{
        this.listData = res.obj
      })
    }
  },
  created(){
    this.formValue.weekTime = moment(new Date()).format('YYYY-MM-DD')
    this.formValue.conveneCode = this._user.usercode;
    this.formValue.conveneName = this._user.username;
    this.refid = this.$util.getUuid();
    // this.getCurrentMonthList()  //获取当前月数据
    this.getUserList()//获取代理商
    this.selectChannel()// 获取渠道

  },
  mounted(){

  }
}
</script>
<style scoped lang="scss">
.h-rowCon{
  font-size: 14px!important;
  font-weight: 400!important;
}
::v-deep .el-form-item__content{
  line-height: 30px;
}
::v-deep .meeting-table  th ,td {
  text-align: center!important;
  border: 1px solid #303133!important;
  border-right: none!important;
  border-bottom: none!important;
  vertical-align:middle;
  font-weight: normal!important;
}
.bordered-spacing{
  border-spacing: 0!important;
  border-right: 1px solid #303133!important;
  border-bottom: 1px solid #303133!important;
}

::v-deep .el-input__inner{
  height: 30px;
  line-height: 30px;
}
::v-deep .my-label {
  background: #fff2e5!important;
}
::v-deep .my-label-lab {
  //background: #E8F5F8!important;
}
::v-deep .el-input__inner{
  background: #E8F5F8!important;
}
::v-deep .el-textarea__inner{
  background: #E8F5F8!important;
}
::v-deep.ljjtablepaddings1 .h-tableInput .el-input__icon{
  line-height: 0.25rem;
}
::v-deep .el-input__icon{
  line-height: 30px;
}
::v-deep .el-form-item {
  margin-bottom: 0 !important;
}
::v-deep .el-descriptions :not(.is-bordered) .el-descriptions-item__cell{
  padding-bottom: 0;
}
::v-deep .el-descriptions .is-bordered .el-descriptions-item__cell{
  padding: 6px;
}
.new-yulan{
  width: 100%;
  margin: 0 auto;
}
.new-yulan ul li{
  padding:5px 0
}
.new-yulan ul li h3{
  text-align: left;
  font-weight: 400;
  color: #0e75e9;
  font-size: 14px
}
.new-yulan ul li h3 i{
  padding: 0 5px;
  color: #606266
}
.new-yulan ul li h3 span{
  text-align: right;
  color: #606266;
  float: right;
  font-size: 13px
}
</style>
